import { render, staticRenderFns } from "./Kobido.vue?vue&type=template&id=06486117&scoped=true&"
import script from "./Kobido.vue?vue&type=script&lang=js&"
export * from "./Kobido.vue?vue&type=script&lang=js&"
import style0 from "./Kobido.vue?vue&type=style&index=0&id=06486117&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06486117",
  null
  
)

export default component.exports